import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7013b486")

_pushScopeId("data-v-7013b486")
const _hoisted_1 = { class: "panel-wrapper" }
const _hoisted_2 = { class: "title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_component_el_divider)
  ]))
})